module.exports = __webpack_public_path__ + "img/thumbblacksheep2.f882ca68.png";